<template>
  <div class="fs-menu-group">
    <div class="fs-menu-group__title">{{ title }}</div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'fs-menu-group',

  props: {
    title: {
      type: String,
      require: true,
    },
  },
};
</script>

<style scoped lang="scss">
@import '@styles/variables';
@import '@styles/text';

.fs-menu-group {
  &__title {
    @include option-group-title;
    margin: 0.7rem 0 2px 0.8rem;
  }
}
</style>
